import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import { combineDateAndHour } from "venuescanner-js/utils";
import moment from "moment";
import { getTimeOption, getTimesAfter } from "./helpers";

const EndTimeInput = ({
  hasError,
  value,
  onChange,
  startDate,
  startTime,
  endDate,
  className,
  disabled,
  Component = "select",
}) => {
  const minDate = startDate || moment();

  const timeOptions = useMemo(
    () =>
      getTimesAfter(
        combineDateAndHour(minDate, startTime || "08:00"),
        endDate || minDate
      ),
    [minDate, startTime, endDate]
  );
  useEffect(() => {
    if (!timeOptions.includes(value)) onChange(timeOptions[0]);
  }, [timeOptions, onChange, value]);

  return (
    <label
      htmlFor="enq-time-to"
      className={cl("ux-select", className)}
      data-error={hasError}
    >
      <Component
        id="enq-time-to"
        value={value || ""}
        onChange={({ target }) => onChange(target.value)}
        disabled={disabled}
      >
        {timeOptions.map(getTimeOption)}
      </Component>
    </label>
  );
};

EndTimeInput.propTypes = {
  hasError: PropTypes.bool.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(moment),
  startTime: PropTypes.string,
  endDate: PropTypes.instanceOf(moment),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default EndTimeInput;
